module.exports = __webpack_public_path__ + "fonts/Poppins-600-latin15.9114501.woff2";